<template>
  <div id="right-side-bar" :class="[ isOpen ? 'open' : '' ]">
    <span class="close-float-top-right">
      <i class="fa fa-times" @click="close"></i>
    </span>
    <div id="right-side-bar-content">
      <form @submit.prevent="$emit('sidebarSubmitted')">
        <component :is="component" :isOpen="isOpen" :callerId="callerId" :event="event" :initData="data" :title="title"></component>
        <input type="submit" style="display:none;"/>
      </form>
    </div>
  </div>
</template>
<script>
  import VueScrollTo from 'vue-scrollto'
  import event from '../event'
  import AccessorialFilter from '../modules/admin/components/Accessorial/AccessorialFilter'
  import BrandGroupFilter from '../modules/admin/components/BrandGroup/BrandGroupFilter'
  import LocationLookup from './LocationLookup.vue'
  import LocationFilter from '../modules/admin/components/Location/LocationFilter.vue'
  import CalculationFilter from '../modules/admin/components/Calculation/CalculationFilter.vue'
  import ConsolidationPointFilter from '../modules/admin/components/ConsolidationPoint/ConsolidationPointFilter.vue'
  import CountryFilter from '../modules/admin/components/Country/CountryFilter.vue'
  import CurrencyFilter from '../modules/admin/components/Currency/CurrencyFilter.vue'
  import ExchangeRateFilter from '../modules/admin/components/ExchangeRate/ExchangeRateFilter.vue'
  import ExchangeRateHistoryFilter from '../modules/admin/components/ExchangeRateHistory/ExchangeRateHistoryFilter.vue'
  import RoleFilter from '../modules/admin/components/Role/RoleFilter.vue'
  import RequestForProposalFilter from '../modules/admin/components/RequestForProposal/RequestForProposalFilter.vue'
  import DataOptionTypeFilter from '../modules/admin/components/DataOptionType/DataOptionTypeFilter.vue'
  import DataOptionFilter from '../modules/admin/components/DataOption/DataOptionFilter.vue'
  import DocumentFilter from '../modules/admin/components/Document/DocumentFilter.vue'
  import FinancialCodeFilter from '../modules/admin/components/FinancialCode/FinancialCodeFilter.vue'
  import FinancialProfileFilter from '../modules/admin/components/FinancialProfile/FinancialProfileFilter.vue'
  import JobTypeFilter from '../modules/admin/components/JobType/JobTypeFilter.vue'
  import JobFilter from '../modules/admin/components/Job/JobFilter.vue'
  import PartyFilter from '../modules/admin/components/Party/PartyFilter.vue'
  import PortAreaFilter from '../modules/admin/components/PortArea/PortAreaFilter.vue'
  import PointToPortFilter from '../modules/admin/components/PointToPort/PointToPortFilter.vue'
  import PartyLookup from './PartyLookup.vue'
  import PartyGroupFilter from '../modules/admin/components/PartyGroup/PartyGroupFilter.vue'
  import QuoteTaxFilter from '../modules/admin/components/QuoteTax/QuoteTaxFilter'
  import RoutingRuleFilter from '../modules/admin/components/RoutingRule/RoutingRuleFilter.vue'
  import SpreadsheetDescriptorFilter from '../modules/admin/components/SpreadsheetDescriptor/SpreadsheetDescriptorFilter.vue'
  import TariffFilter from '../modules/admin/components/Tariff/TariffFilter.vue'
  import TariffMergeFilter from '../modules/tariffmerge/components/TariffMergeFilter.vue'
  import TransitMileFilter from '../modules/admin/components/TransitMile/TransitMileFilter.vue'
  import UserGroupFilter from '../modules/admin/components/UserGroup/UserGroupFilter.vue'
  import UserFilter from '../modules/admin/components/User/UserFilter.vue'
  import VendorZoneFilter from '../modules/admin/components/VendorZone/VendorZoneFilter.vue'

  export default {
    name: 'RightSidebar',
    components: {
      AccessorialFilter,
      BrandGroupFilter,
      location: LocationLookup,
      LocationFilter,
      CalculationFilter,
      ConsolidationPointFilter,
      CountryFilter,
      CurrencyFilter,
      ExchangeRateFilter,
      ExchangeRateHistoryFilter,
      RoleFilter,
      DataOptionTypeFilter,
      DataOptionFilter,
      DocumentFilter,
      FinancialCodeFilter,
      FinancialProfileFilter,
      JobFilter,
      JobTypeFilter,
      PartyFilter,
      PartyGroupFilter,
      PortAreaFilter,
      PartyLookup,
      PointToPortFilter,
      QuoteTaxFilter,
      RoutingRuleFilter,
      SpreadsheetDescriptorFilter,
      TariffFilter,
      TariffMergeFilter,
      TransitMileFilter,
      UserGroupFilter,
      UserFilter,
      VendorZoneFilter,
      RequestForProposalFilter
    },
    data () {
      return {
        component: null,
        isOpen: false,
        callerId: null,
        event: null,
        data: {},
        title: '',
        contentHeightInterval: null
      }
    },
    methods: {
      open ({callerId, component, data, event, title}) {
        this.isOpen = true
        this.component = component
        this.event = event
        this.callerId = callerId
        this.data = data
        this.title = title
        setTimeout(this.scrollTo, 250)
      },
      scrollTo () {
        VueScrollTo.scrollTo('#right-side-bar', 250, {})
      },
      hide () {
        this.isOpen = false
      },
      close () {
        this.isOpen = false
        this.component = null
      },
      checkHeight () {
        const mainContent = document.querySelector('.content-wrapper')
        if (mainContent && (mainContent.offsetHeight < this.$el.querySelector('#right-side-bar-content').offsetHeight)) {
          mainContent.style.minHeight = `${this.$el.querySelector('#right-side-bar-content').offsetHeight}px`
        }
      }
    },
    created () {
      event.$on('right-open', this.open)
      event.$on('right-close', this.hide)
      event.$on('right-close-and-destroy', this.close)
    },
    beforeDestroy () {
      event.$off('right-open', this.open)
      event.$off('right-close', this.hide)
      event.$off('right-close-and-destroy', this.close)
      window.clearInterval(this.contentHeightInterval)
    },
    mounted () {
      this.$nextTick(() => {
        this.contentHeightInterval = window.setInterval(this.checkHeight, 250)
      })
    }
  }
</script>

<style scoped>
#right-side-bar {
  position: absolute;
  width: 300px;
  background: rgba(0, 0, 0, 0.9);
  height: 100%;
  z-index: 9995;
  transform: translateX(300px);
  transition: transform 0.5s;
  right:0;
  overflow: auto;
  padding: 10px;
}
#right-side-bar.open {
  transform: translateX(0px);
}
.close-float-top-right {
  position: absolute;
  top: 5px;
  right: 8px;
}
.close-float-top-right i {
  cursor: pointer;
  color: #fff;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// RightSidebar.vue?06dc14e3